export const iconFontAwesomeCharityHandsHoldingChild = (
	<i className="fa-solid fa-hands-holding-child"></i>
);
